import { useState } from "react";
import { Button } from "../../newlogin/components/ui/button";
import { Menu, X } from "lucide-react";
import { getOrgConfig } from "../../../utils/organizationConfigUtil";
// Replace next/link with a simple anchor tag or React Router Link if you use it
// Replace next/image with a regular img tag

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const imageSrc = getOrgConfig()?.logo;
  const altText = getOrgConfig()?.companyName;
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a href="/" className="flex-shrink-0">
            <img
              src={imageSrc}
              alt={altText}
              width={200}
              height={60}
              className="h-8 lg:h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="lg:flex items-center space-x-8">
            <div className="flex items-center space-x-6">
              <a href="#features" className="text-gray-700 hover:text-blue-600 font-medium" >
                About
              </a>
              <a href="https://witty-field-0ca292d1e.4.azurestaticapps.net/quickprice" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-blue-600 font-medium">
                Quick Pricer
              </a>
            </div>
          </nav>

          {/* Desktop Right Side */}
          {/* <div className="lg:flex items-center space-x-4">
            <div className="flex items-center space-x-4 text-sm text-gray-600">
              <a href="/partner" className="hover:text-blue-600">
                Partner With Us
              </a>
              <a href="/correspondent" className="hover:text-blue-600">
                Correspondent
              </a>
              <a href="/contact" className="hover:text-blue-600">
                Contact Us
              </a>
            </div>
          </div> */}

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center space-x-2">
            <Button variant="ghost" size="icon" onClick={toggleMenu} className="text-gray-700">
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t bg-white">
            <nav className="py-4 space-y-4">
              <a href="/about" className="block text-gray-700 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)}>
                About
              </a>
              <a href="/wholesale-pricer" className="block text-gray-700 hover:text-blue-600 font-medium py-2" onClick={() => setIsMenuOpen(false)}>
                Wholesale Quick Pricer
              </a>
              <div className="border-t pt-4 space-y-2">
                <a href="/partner" className="block text-gray-600 hover:text-blue-600 py-1" onClick={() => setIsMenuOpen(false)}>
                  Partner With Us
                </a>
                <a href="/correspondent" className="block text-gray-600 hover:text-blue-600 py-1" onClick={() => setIsMenuOpen(false)}>
                  Correspondent
                </a>
                <a href="/contact" className="block text-gray-600 hover:text-blue-600 py-1" onClick={() => setIsMenuOpen(false)}>
                  Contact Us
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
